import classNames from "classnames";
import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";

import { useMainStore } from "@/contexts/Store";

import closeIcon from "../../../images/table-image/icon/close-black-icon.svg";
import { getWorkspaceLogo } from "../../helpers/getWorkspaceLogo";

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emailSlideClose?: (...args: any[]) => any;
  recordName?: string;
  recordVersionID: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  sendFunction?: (...args: any[]) => any;
};

function SendRecordVersion({
  emailSlideClose,
  recordVersionID,
  recordName,
  sendFunction,
}: Props) {
  // Import MobX stores
  const mainStore = useMainStore();

  // State
  const [selectedRecordVersionIDs, setSelectedRecordVersionIDs] = useState([]);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [selectedWorkspaceIDs, setSelectedWorkspaceIDs] = useState([]);

  // Hooks
  useEffect(() => {
    if (
      selectedRecordVersionIDs.length > 0 &&
      selectedWorkspaceIDs.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [selectedRecordVersionIDs, selectedWorkspaceIDs]);

  useEffect(() => {
    // Copy selection from DynamicTable store
    const newSelection =
      mainStore.dynamicTable.selectedRecordVersionIDs.slice();

    // Add single selection if any
    if (recordVersionID) {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      newSelection.push(recordVersionID);
    }

    setSelectedRecordVersionIDs(newSelection);
  }, [recordVersionID, mainStore.dynamicTable.selectedRecordVersionIDs]);

  function onSend() {
    if (!sendFunction) {
      mainStore.recordVersions.send(recordVersionID, selectedWorkspaceIDs);
    } else {
      sendFunction(recordVersionID, selectedWorkspaceIDs);
    }
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    emailSlideClose();
  }

  // @ts-expect-error TS(7006) FIXME: Parameter 'id' implicitly has an 'any' type.
  function addWorkspaceById(id) {
    // @ts-expect-error TS(2322) FIXME: Type 'any' is not assignable to type 'never'.
    setSelectedWorkspaceIDs([...selectedWorkspaceIDs, id]);

    selectedWorkspaceIDs.forEach((element) => {
      if (element === id) {
        const newSelectionWorkspace = selectedWorkspaceIDs.filter(
          (elem) => elem !== id,
        );
        setSelectedWorkspaceIDs(newSelectionWorkspace);
      }
    });
  }

  const buttonClasses = classNames({ active: !buttonDisabled });

  const selectedRecordVersions = mainStore.recordVersions.list
    .filter(
      // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
      (recordVersion) => selectedRecordVersionIDs.includes(recordVersion.id),
    )
    .map((recordVersion) => {
      const description = mainStore.avroSchemas.valueForField(
        "description",
        recordVersion.data,
      );

      return (
        <div key={recordVersion.id} className="table-email-element">
          {recordVersion.meta?.name || description}
        </div>
      );
    });

  const renderWorkspaces = mainStore.workspaces.collaborativeWorkspaces
    .filter(
      (workspace) => workspace.id !== mainStore.context.activeWorkspace?.id,
    )
    .map((workspace) => {
      const { logo, isInternal } = getWorkspaceLogo(workspace);
      const workspaceActive = classNames({
        // @ts-expect-error TS(2345) FIXME: Argument of type 'number' is not assignable to par... Remove this comment to see the full error message
        active: selectedWorkspaceIDs.indexOf(workspace.id) !== -1,
      });

      return (
        <li
          data-testid={`send-workspace-block-${workspace.id}`}
          key={workspace.id}
          className={workspaceActive}
          onClick={() => {
            addWorkspaceById(workspace.id);
          }}
        >
          <img src={logo} alt="image" />
          <div className="creative-block">
            <h3>{isInternal ? workspace.company.name : workspace.name}</h3>
            {/* @ts-expect-error TS(2339) FIXME: Property 'members_count' does not exist on type 'W... Remove this comment to see the full error message */}
            <span>{workspace.members_count} members</span>
          </div>
        </li>
      );
    });

  return (
    <div className="table-dropdown table-email-dropdown">
      <div className="email-dropdown-head">
        <h3>Send {recordName}</h3>
        <div onClick={emailSlideClose}>
          <img src={closeIcon} alt="close-icon" />{" "}
        </div>
      </div>
      {selectedRecordVersions.length > 0 && (
        <div className="table-email-single-select">
          <div className="table-email-block">{selectedRecordVersions}</div>
        </div>
      )}
      <hr />
      <div className="email-dropdown-wrap">
        <div className="creative-wrap">
          <h4>
            Select a Collaborative Workspace below to send{" "}
            <blockquote>{recordName}</blockquote>
          </h4>
          <ul>{renderWorkspaces}</ul>
        </div>
        <button
          className={buttonClasses}
          disabled={buttonDisabled}
          onClick={onSend}
          data-testid="send-button"
        >
          Send
        </button>
      </div>
      <hr />
    </div>
  );
}

export default observer(SendRecordVersion);
